export default __webpack_public_path__ + "static/media/1.ed3a0adb.jpg";